<div class="container">
  <div class="card">
    <div class="task-head">
      <h4 *ngIf="data.type === 'success'">Success!</h4>
      <h4 *ngIf="data.type === 'error'">Error!</h4>
      <h4 *ngIf="data.type === 'warning'">Warning!</h4>
    </div>

    <p>{{ data.message }}</p>
  </div>

  <div class="btns">
    <button 
      *ngFor="let button of data.buttons"
      mat-flat-button
      (click)="onButtonClick(button)"
    >
      {{ button.text }}
    </button>
  </div>
</div>
